import { useSyncExternalStore } from 'react';

const applyTheme = (isDarkMode: boolean) => {
  if (isDarkMode) {
    document.documentElement.setAttribute('data-theme', 'dark');
  } else {
    document.documentElement.removeAttribute('data-theme');
  }
};

let isDarkMode = localStorage.getItem('darkMode') === 'true';
applyTheme(isDarkMode);

const listeners = new Set<() => void>();

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

const getSnapshot = () => isDarkMode;

const setDarkMode = (value: boolean) => {
  if (value === isDarkMode) return;
  isDarkMode = value;
  localStorage.setItem('darkMode', String(value));
  applyTheme(value);
  listeners.forEach(listener => listener());
};

const useDarkMode = (): [boolean, (val: boolean) => void] => {
  const isDarkMode = useSyncExternalStore(subscribe, getSnapshot);
  return [isDarkMode, setDarkMode];
};

export default useDarkMode;
